/* HitchFire hero — background video + rotating headline line (sections/hero-carousel.liquid).
   External asset on purpose: the vsly A/B test mangles inline section scripts.
   - Starts after window load (or 1.2s after DOM ready) so the poster image (LCP) loads first.
   - Use Shopify's transcoded renditions (/videos/c/vp/...): they are faststart and begin playing
     while downloading. Raw uploads (/videos/c/o/v/...) can have the index at the end and must
     download fully before the first frame.
   - Skips the video for reduced motion and Save-Data; the slide image stays.
   - Phones (<768px) get data-src-sm. Video fades in only once it is actually playing.
   - In a multi-slide carousel, only the active slide's video plays. */
(function () {
  'use strict';
  var vids = [].slice.call(document.querySelectorAll('[data-hf-hero-video]'));
  if (!vids.length) return;
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sd = navigator.connection && navigator.connection.saveData;
  if (rm || sd) return;

  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function active(v) { var bg = v.parentNode; return !bg || !bg.classList || bg.classList.contains('is-on') || vids.length === 1; }

  function start() {
    var small = window.innerWidth < 768;
    vids.forEach(function (v) {
      var src = small ? v.getAttribute('data-src-sm') : v.getAttribute('data-src-lg');
      if (!src) return;
      v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      v.addEventListener('error', function () { v.classList.remove('is-playing'); });
      v.src = src;
      v.preload = 'auto';
      if (active(v)) play(v);
      if (vids.length > 1 && window.MutationObserver) {
        new MutationObserver(function () {
          if (active(v)) play(v); else v.pause();
        }).observe(v.parentNode, { attributes: true, attributeFilter: ['class'] });
      }
    });
    document.addEventListener('visibilitychange', function () {
      vids.forEach(function (v) { if (document.hidden) v.pause(); else if (active(v) && v.src) play(v); });
    });
  }

  /* Start on window load, or 1.2s after the DOM is ready if load is slow (third-party apps),
     whichever comes first. The poster image is preloaded at high priority either way. */
  var started = false;
  function go() { if (started) return; started = true; start(); }
  if (document.readyState === 'complete') go();
  else {
    window.addEventListener('load', go);
    var arm = function () { setTimeout(go, 1200); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  }
})();

/* Rotating headline line: [data-hf-rotate="a|b|c"]. Static first phrase under reduced motion.
   Each phrase wipes in left to right (like it is being typed, but smooth) and wipes back out
   right to left. The clip runs on the whole orange .hero-mark so the bar grows with the word.
   Web Animations API with no fill: the resting style is always fully visible, even if an
   animation is interrupted or throttled. */
(function () {
  'use strict';
  var el = document.querySelector('[data-hf-rotate]');
  if (!el) return;
  var words = (el.getAttribute('data-hf-rotate') || '').split('|').filter(Boolean);
  if (words.length < 2) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var mark = (el.closest && el.closest('.hero-mark')) || el;
  var i = 0, HOLD = 2400, OUT = 320, IN = 700;
  var SHUT = 'inset(-20% 120% -20% -20%)', OPEN = 'inset(-20% -20% -20% -20%)';
  var canAnimate = typeof mark.animate === 'function';
  function next() {
    if (document.hidden) return;
    if (!canAnimate) { i = (i + 1) % words.length; el.textContent = words[i]; return; }
    var out = mark.animate([{ clipPath: OPEN }, { clipPath: SHUT }], { duration: OUT, easing: 'cubic-bezier(0.65,0,0.35,1)', fill: 'forwards' });
    setTimeout(function () {
      i = (i + 1) % words.length;
      el.textContent = words[i];
      mark.animate([{ clipPath: SHUT }, { clipPath: OPEN }], { duration: IN, easing: 'cubic-bezier(0.22,1,0.36,1)' });
      out.cancel();
    }, OUT);
  }
  setInterval(next, HOLD + OUT + IN);
})();
